module.exports = __webpack_public_path__ + "img/cnr-no-bg.56bf0768.png";